import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Field, Input, Text, VStack, Center, Image } from '@chakra-ui/react';
import Logo from '@/assets/images/cyberjob_dialogflow_logo.svg';
import { toaster } from '@/components/ui/toaster';
import ActivationService from '@/services/ActivationService';

const ForgotPasswordPage = () => {
    const { t } = useTranslation('login');
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        setIsSubmitting(true);
        try {
            await ActivationService.requestPasswordReset(email);
        } catch {
            // intentionally silent — don't reveal whether email exists
        } finally {
            setIsSubmitting(false);
            setSubmitted(true);
        }
    };

    return (
        <Center minH="100vh" w="100vw" bg="bg.primary" px={{ base: 4, md: 0 }}>
            <Box w="full" maxW="400px" p={{ base: 6, md: 8 }} bg="bg.secondary" borderRadius={16}>
                <VStack gap={6} as="form" onSubmit={handleSubmit}>
                    <Image src={Logo} w="70%" mb={2} />
                    <Text fontSize={24} color="white" fontWeight="bold">{t('forgotPasswordPage.title')}</Text>

                    {submitted ? (
                        <>
                            <Text color="text.grey" textAlign="center">
                                {t('forgotPasswordPage.submittedMessage')}
                            </Text>
                            <Button variant="primary" w="full" onClick={() => navigate('/login')}>
                                {t('forgotPasswordPage.backToLogin')}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Field.Root required w="full">
                                <Field.Label color="white">{t('forgotPasswordPage.emailLabel')} <Field.RequiredIndicator /></Field.Label>
                                <Input
                                    variant="primary"
                                    type="email"
                                    placeholder={t('forgotPasswordPage.emailPlaceholder')}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </Field.Root>

                            <Button variant="primary" type="submit" w="full" loading={isSubmitting}>
                                {t('forgotPasswordPage.submit')}
                            </Button>

                            <Button variant="ghost" w="full" onClick={() => navigate('/login')}>
                                {t('forgotPasswordPage.backToLogin')}
                            </Button>
                        </>
                    )}
                </VStack>
            </Box>
        </Center>
    );
};

export default ForgotPasswordPage;
